import styles from './RegulatoryComplianceStrip.module.css';

interface RegulatoryComplianceStripProps {
  frameworks?: string[];
  onDark?: boolean;
}

const defaultFrameworks = [
  'HIPAA', 'SOX', 'GDPR', 'FDA 21 CFR Part 11', 'FINRA', 'Basel III', 'GxP', 'ISO 27001',
];

export function RegulatoryComplianceStrip({
  frameworks = defaultFrameworks,
  onDark = false,
}: RegulatoryComplianceStripProps) {
  return (
    <div className={[styles.strip, onDark ? styles.onDark : ''].filter(Boolean).join(' ')}>
      <span className={styles.label}>Compliance:</span>
      {frameworks.map((fw) => (
        <span key={fw} className={styles.badge}>
          <span className={styles.badgeDot} aria-hidden="true" />
          {fw}
        </span>
      ))}
    </div>
  );
}
